import React, { useMemo } from "react";
import { Card, Tooltip } from "antd";
import { PeriodDateUtils } from "../../utils/dates";

// Extract providers as a constant to avoid recreation
const PROVIDERS = [
    "GoogleADX",
    "Google_2_ADX", 
    "GoogleGTD",
    "Google_RRO",
    "Google_OB_RRO",
    "Google_Realitatea",
    "Smart",
    "EQT_RRO",
    "SW_RRO",
    "Teads",
    "Criteo",
    "CRT_RRO",
    "RichAudience",
    "Rubicon",
    "Pubmatic",
    "Xandr",
    "Adform",
    "ADF_RRO",
    "Seedtag",
    "STG_RRO",
    "RTBHouse",
    "RTBH_RRO",
    "SOV_RRO",
    "AGR_RRO",
    "Teads_RRO",
    "Taboola",
    "Admixer",
    "YOC",
    "WPartner",
    "Nano",
    "Caroda",
    "Sparteo",
    "Ogury",
    "ConnectAd",
    "R2B2",
    "GoogleTHD",
    "GoogleDealsTHD",
    "GoogleDirectTHD",
    "GoogleOpenBiddingTHD",
    "AdformTHD",
    "TeadsTHD",
    "RichAudienceTHD",
    "LetThereBeAdsTHD",
    "OrangeClickMediaTHD",
    "SparteoTHD",
    "OguryTHD",
    "OnnetworkTHD",
    "RTBHouseTHD",
    "SmartTHD",
    "ItaliaOnlineTHD",
    "WPartnerTHD"
];

const CronHeatmap = ({ list = [] }) => {
    // Move days inside component to avoid stale data
    const days = useMemo(() => PeriodDateUtils.getLast30Days(), []);
    // Memoize the execution data processing
    const executedDays = useMemo(() => {
        if (!list.length) return {};
        
        // Initialize with Set for O(1) lookups and automatic deduplication
        const executed = PROVIDERS.reduce((acc, provider) => {
            acc[provider] = new Set();
            return acc;
        }, {});
        
        // Single pass through the list with optimized logic
        list.forEach(item => {
            if (item?.jobName && item?.executionTime && executed[item.jobName]) {
                const date = item.executionTime.split('T')[0];
                executed[item.jobName].add(date);
            }
        });
        
        return executed;
    }, [list]);

    // Early return if no data
    if (!list.length) {
        return (
            <div style={{ padding: 24 }}>
                <p>No execution data available</p>
            </div>
        );
    }

    return (
        <div style={{ padding: 24 }}>
            {PROVIDERS.map(provider => {
                const providerExecutions = executedDays[provider];
                return (
                    <Card
                        key={provider}
                        title={provider}
                        size="small"
                        style={{ marginBottom: 16 }}
                    >
                        <div style={{ 
                            display: "flex", 
                            gap: 4, 
                            flexWrap: "wrap" 
                        }}>
                            {days.map(day => {
                                const isExecuted = providerExecutions?.has(day);
                                return (
                                    <Tooltip
                                        key={day}
                                        title={`${provider} - ${day}: ${
                                            isExecuted ? "Executed" : "Missed"
                                        }`}
                                    >
                                        <div
                                            style={{
                                                width: 20,
                                                height: 20,
                                                backgroundColor: isExecuted 
                                                    ? "#52c41a" 
                                                    : "#ff4d4f",
                                                borderRadius: 4,
                                            }}
                                        />
                                    </Tooltip>
                                );
                            })}
                        </div>
                    </Card>
                );
            })}
        </div>
    );
};

export default CronHeatmap;